import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=2f70ed33&scoped=true&lang=pug"
import script from "./ProgressBar.vue?vue&type=script&lang=ts"
export * from "./ProgressBar.vue?vue&type=script&lang=ts"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=2f70ed33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f70ed33",
  null
  
)

export default component.exports